export default {
	GET_CURRENT: () => "/crew/current",
	GET_MEMBERS: (id) => `/crew/${id}/members`,
	GET_INVITATION: (invitationId) => `/crew/invitation?invitationId=${invitationId}`,
	ACCEPT_INVITATION: (invitationId) => `/crew/invitation/accept?invitationId=${invitationId}`,
	CREATE: () => "/crew",
	UPDATE_NAME: (id) => `/crew/${id}/name`,
	UPDATE_MEMBER_ROLE: (id) => `/crew/${id}/member/role`,
	DELETE_MEMBER: ({ crewId, userId }) => `/crew/${crewId}/member/${userId}`,
	RENEW_INVITATION: (id) => `/crew/${id}/invitation/renew`,
	DELETE: (id) => `/crew/${id}`,
};
